import { practiceSuiteUpload } from '@fireflyhealth/api'

export const uploadPracticeSuiteInvoice = async (file: FormData) => {
  const response = await practiceSuiteUpload.create({ data: file })

  return response.data
}
